<template>
    <v-card>
        <v-card-title>
            CMS Tab
        </v-card-title>
        <v-card-subtitle>
            These controls can be used to hide/show function tabs on the cms for <b>company admin</b> and <b>event admin</b> of this event.
        </v-card-subtitle>

        <v-data-table :headers="headers"
                      :items="items"
                      :loading="isPending"
                      :items-per-page="items.length"
                      hide-default-footer
                      disable-sort>
            

            <template v-slot:item.title="{value}">
                {{value}}
            </template>
            <template v-slot:item.status="{value}">
                {{value}}
                <!-- <v-textarea v-model="">
                    {{switchLabel(value)}}
                </v-textarea> -->
            </template>
            <template v-slot:item.actions="{value}">
                 <v-switch v-model="eventCmsTabData[value]"
                    @change="onChange($event,value)"
                    >
                </v-switch>
            </template>
            
        </v-data-table>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary"
                   @click="saveEventCmsTab" :disabled="false">
                {{$t('save')}}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<style >

.v-input--expand >>> .v-input__slot >>> .v-label {
    display: block;
    flex: 1;
}
</style>
<script>
    import {computed, reactive, ref,watch} from '@vue/composition-api';
    import {useFind} from "feathers-vuex";

    export default {
        name: 'EventCmsTab',
        setup(props, {root}){
            const {EventCmsTab} = root.$FeathersVuex.api;

            const eventId = computed(()=> root.$route.params.eventId);
            const eventCmsTabParams = computed(() => {
                return {
                    query: {
                        eventId: eventId.value
                    }
                }
            });
            const {items: eventCmsTabList, isPending} = useFind({model: EventCmsTab, params: eventCmsTabParams});

            const eventCmsTabData = ref({});
            const eventCmsTabFieldMap = reactive({});

            const switchLabel = function(value){
                return value?"\tEnabled":"\tDisabled"
            }

            const headers = ref([
                {text: root.$t('cms_tab.title'),value:'title'},
                {text: root.$t('cms_tab.status'),value:'status'},
                {text: '',value:'actions'},
            ])

            const saveEventCmsTab = function() {                
                eventCmsTabData.value.save().then(()=>{
                    root.$store.dispatch('showSnackBar',root.$t('cms_tab.save_successful'));
                }, root.$handleFeatherError.bind(root));
            }

            const items = reactive([])

            watch(isPending, (newVal, oldVal) => {
                if (!newVal && oldVal) {
                    if (eventCmsTabList.value.length == 0) {
                        eventCmsTabData.value = new EventCmsTab({ eventId: eventId.value })
                        Object.assign(eventCmsTabFieldMap, eventCmsTabData.value)
                    } else {
                        eventCmsTabData.value = eventCmsTabList.value[0]
                        Object.assign(eventCmsTabFieldMap, eventCmsTabData.value)
                    }
                    const removeFields = ['__id', '__isTemp', 'id', 'eventId', 'createdAt', 'updatedAt', 'deletedAt'];
                    for (let i=0; i<removeFields.length; i++) {
                        delete eventCmsTabFieldMap[removeFields[i]];
                    }
                    items.splice(0, items.length)
                    for (const [key, isEnabled] of Object.entries(eventCmsTabFieldMap)) {
                        items.push({
                            'title': key,
                            'status': switchLabel(isEnabled),
                            'actions': key,
                        })
                    }
                }
            })

            const indexOf = function(fieldTitle){
                for(let i=0;i<items.length;i++){
                    if(items[i].actions==fieldTitle){
                        return i;
                    }
                }
                return -1;
            }

            const onChange = function(e,fieldTitle){
                items[indexOf(fieldTitle)].status = switchLabel(e)
            }
            
            const itemsLength = ref(items.length)

            return {
                switchLabel,

                eventCmsTabData,
                eventCmsTabFieldMap,
                saveEventCmsTab,

                headers,
                items,
                itemsLength,
                isPending,
                onChange
            }
        }
    }
</script>